import React from 'react'

const WorkOrders = () => {
  return <h2>WorkOrders!</h2>
}

export default WorkOrders
